import { render, staticRenderFns } from "./Fisica.vue?vue&type=template&id=51407284&scoped=true&"
import script from "./Fisica.vue?vue&type=script&lang=js&"
export * from "./Fisica.vue?vue&type=script&lang=js&"
import style0 from "./Fisica.vue?vue&type=style&index=0&id=51407284&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51407284",
  null
  
)

export default component.exports